/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetManufacturerResponse
 */
export interface AssetManufacturerResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetManufacturerResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AssetManufacturerResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetManufacturerResponse
     */
    description?: string;
}

/**
 * Check if a given object implements the AssetManufacturerResponse interface.
 */
export function instanceOfAssetManufacturerResponse(value: object): value is AssetManufacturerResponse {
    return true;
}

export function AssetManufacturerResponseFromJSON(json: any): AssetManufacturerResponse {
    return AssetManufacturerResponseFromJSONTyped(json, false);
}

export function AssetManufacturerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetManufacturerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function AssetManufacturerResponseToJSON(json: any): AssetManufacturerResponse {
    return AssetManufacturerResponseToJSONTyped(json, false);
}

export function AssetManufacturerResponseToJSONTyped(value?: AssetManufacturerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

